import angular from 'angular';
import 'angular-jwt';
import 'angular-recaptcha';
import { localStorage } from '../utils';
import '../app.constants';
import '../services/auth';
import '../services/user';
import '../services/globals';
import '../services/errors';
import { get } from 'lodash';

const module = angular.module('whyline.controllers.sign-in', [
  'angular-jwt',
  'vcRecaptcha',
  'whyline.constants',
  'whyline.services.auth',
  'whyline.services.user',
  'whyline.services.globals',
  'whyline.services.errors',
]);

const SignInController = (
  SAFE_STATES,
  $window,
  $scope,
  $state,
  jwtHelper,
  AuthService,
  NotificationService,
  GlobalsService,
  ErrorService,
  $translate,
  dialog,
  PUBLIC_KEY,
  API_URL,
) => {
  let oneLoginUrl = '';
  /*@ngInject*/

  // Enterprise type for branding
  $scope.enterpriseType = GlobalsService.EnterpriseType;
  $scope.currentYear = new Date().getFullYear();
  $scope.currentLanguage = $translate.use();
  $scope.loading = true;
  $scope.recap = {
    publicKey: PUBLIC_KEY,
  };
  // Init
  $scope.signInData = {
    email: null,
    password: null,
  };

  $scope.domains = [];
  $scope.isIE = false;
  $scope.isEdge = false;
  $scope.showPassword = false;
  $scope.passwordType = 'password';
  $scope.showOptionDirectory = false;
  
  const token = localStorage.get('token');

  if (token && !jwtHelper.isTokenExpired(token)) {
    return $state.go(SAFE_STATES.organizationsList);
  }

  // Internet Explorer 6-11
  $scope.isIE = /*@cc_on!@*/ false || !!document.documentMode;

  // Edge 20+
  $scope.isEdge = !$scope.isIE && !!window.StyleMedia;

  $scope.oneLogin = () => {
    $window.location.href = oneLoginUrl;
  };

  const userWhyline = (captchaResponse) => {
    const { email, password } = $scope.signInData;
    if (!email || email.lenght === 0) {
      return NotificationService.Error($translate.instant('mandatory_email'));
    } else if (!password || password.lenght === 0) {
      return NotificationService.Error($translate.instant('mandatory_password'));
    } else {
      AuthService.SignIn(email, password, captchaResponse)
        .then((data) => {
          if (data.user.sigeci) {
            $state.go(SAFE_STATES.appointments);
          } else {
            $state.go(SAFE_STATES.organizationsList);
          }

          cleanCache();

          return Promise.resolve();
        })
        .catch((err) => {
          const errorCode = get(err, 'data.message', null);

          if (err.status === 409 && errorCode === 'user.should-close-sessions') {
            dialog.confirm($translate.instant('user.should-close-sessions')).then(() => {
              AuthService.CloseSessions(email, password).then(() => {
                $scope.signIn();
              });
            });
          } else {
            ErrorService.handler(err);
          }
        });
    }
  };

  $scope.signIn = () => {
    grecaptcha.ready(() => {
      grecaptcha.execute(PUBLIC_KEY, { action: 'submit' }).then((captchaResponse) => {
        if (captchaResponse !== '') {
          userWhyline(captchaResponse);
        } else {
          return NotificationService.Error($translate.instant('mandatory_captcha'));
        }
      });
    });
  };

  $scope.signInBancoMacro = () => {
    const url = `${API_URL}auth/macro/login`;
    $window.location.href = url;

    cleanCache();
  };

  $scope.toggleShowPassword = () => {
    $scope.showPassword = !$scope.showPassword;
    if ($scope.showPassword) {
      $scope.passwordType = 'text';
    } else {
      $scope.passwordType = 'password';
    }
  };

  /*
  * Clear the cache in the browser, to force to get the last UI version from the server,
  * just before redirecting to the next page
  * */
  const cleanCache = () => {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        // delete cache from the browser
        caches.delete(cacheName);
      });
    }).then(() => {
      // reload the cache avoiding using cache
      location.reload(true);
      // window.location.href = window.location.origin + window.location.pathname + '?refresh=' + new Date().getTime();
      // window.location.assign(window.location.href);
      console.log('Cache cleaned.');
    });
  }

  $scope.loading = false;
};

module.exports = module.controller('SignInController', SignInController);
